import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DocumentTemplateManagementConstants } from '../document-template-management-constants';
import { DocumentTemplateManagementInteractionService } from '../services/document-template-management-interaction.service';
import { DocumentTemplateManagementService } from '../services/document-template-management.service';
import { LabelConstants } from '../../shared/constants/label-constants';

@Component({
  selector: 'app-document-template-management',
  templateUrl: './document-template-management.component.html',
  styleUrls: ['./document-template-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentTemplateManagementComponent implements OnInit, OnDestroy {
  topBarTitle: string = DocumentTemplateManagementConstants.Document_Template_Management;
  isScreenAccessible : boolean = true;
  errorMessage !: string;
  constructor(private documentTemplateManagementInteractionService: DocumentTemplateManagementInteractionService,
    private documentTemplateManagementService: DocumentTemplateManagementService) { }

  ngOnInit(): void {
    this.documentTemplateManagementService.checkAccessibility().subscribe({
      error: (err) => {
        if(err.status === LabelConstants.Forbidden_StatusCode){
          this.errorMessage=err.error.detail;
        }
         this.isScreenAccessible = false
      }
    })
  }
  ngOnDestroy(): void {
    this.documentTemplateManagementInteractionService.documentTemplates$.unsubscribe();
    this.documentTemplateManagementInteractionService.removeScopeSelection$.unsubscribe();
  }

}
